<template>
  <div class="basis-sms-code">
    <!-- native-type="button"， 否则会触发表单提交 -->
    <van-button
      :loading="buttonLoading"
      :disabled="buttonDisabled"
      size="small"
      type="primary"
      plain
      class="get-code-button"
      native-type="button"
      @click="getCode"
    >
      <template v-if="buttonDisabled">
        验证码({{ waittingCount }})
      </template>
      <template v-else>
        获取验证码
      </template>
    </van-button>
  </div>
</template>

<script>
import { Code } from '@/api'

export default {
  name: 'BasisSmsCode',
  props: {
    mobile: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waittingCount: 60,
      buttonLoading: false,
      buttonDisabled: false
    }
  },
  methods: {
    getCode () {
      this.$emit('getCode', async () => {
        try {
          this.buttonLoading = true
          await Code.getSMSCode({ mobile: this.mobile })
          this.buttonLoading = false
          // 成功通知
          this.$notify({ type: 'success', message: '验证码发送成功' })
          this.buttonDisabled = true
          const intervalTime = setInterval(() => {
            if (this.waittingCount > 0) {
              this.waittingCount -= 1
            } else {
              clearInterval(intervalTime)
              this.buttonDisabled = false
              this.waittingCount = 60
            }
          }, 1000)
        } catch (error) {
          console.log(error)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.basis-sms-code {
  .get-code-button {
    @include sc($font-size-md, $color-text-active);
    height: 20px;
    line-height: 20px;
    border: 0;
    background-color: transparent;
  }
}
</style>
